import Vue from "vue";
import Vuex from "vuex";
import productStore from "./productStore";
import registrationStore from "./registrationStore";
import dicStore from "./dicStore";
import addonStore from "./addonStore";
import bundleStore from "./bundleStore";
import subscriptionAddonStore from "./subscriptionAddonStore";
import bundleGroupStore from "./bundleGroupStore";
import discountStore from "./discountStore";
import checkout from "./modules/checkout";
import manufacturer from "./modules/manufacturer";
import cart from "./modules/cart/cart";
import testdrive from "./modules/testdrive";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    dic: dicStore,
    product: productStore,
    registration: registrationStore,
    addon: addonStore,
    bundle: bundleStore,
    bundleGroup: bundleGroupStore,
    subsAddon: subscriptionAddonStore,
    discount: discountStore,
    checkout,
    manufacturer,
    cart,
    testdrive,
  },
});

export default store;
